import { Navigate } from 'react-router'

import { useActivationContext } from '../../providers/activation-provider'

import TurnOnSensorLeakFreeze from './device-types/leak-freeze'
import TurnOnSensorSlim from './device-types/slim'

const TurnOnSensor = () => {
  const {
    activationLocationState: { nodeTypeName },
  } = useActivationContext()

  if (nodeTypeName === 'nbiot_leak') return <TurnOnSensorLeakFreeze />
  if (nodeTypeName === 'leak5s') return <TurnOnSensorSlim />

  return <Navigate to="-1" />
}

export default TurnOnSensor
